function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calculator_svg__cls-2{fill:#1b75bb}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calculator_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "calculator_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 2.5,
  width: 114.4,
  height: 172.52,
  rx: 13.17,
  fill: "none",
  stroke: "#1b75bb",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  className: "calculator_svg__cls-2",
  d: "M95.77 21.32H23.63a12.6 12.6 0 100 25.19h72.14a12.6 12.6 0 100-25.19zM32.62 72.24a10.06 10.06 0 11-10-10 10.05 10.05 0 0110 10zM57.38 72.24a10.06 10.06 0 11-10.06-10 10.05 10.05 0 0110.06 10z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 72.08,
  cy: 72.24,
  r: 10.05
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 96.83,
  cy: 72.24,
  r: 10.05
}), /*#__PURE__*/React.createElement("path", {
  className: "calculator_svg__cls-2",
  d: "M32.62 98.21a10.06 10.06 0 11-10-10.06 10.05 10.05 0 0110 10.06zM57.38 98.21a10.06 10.06 0 11-10.06-10.06 10.05 10.05 0 0110.06 10.06z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 72.08,
  cy: 98.21,
  r: 10.05
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 96.83,
  cy: 98.21,
  r: 10.05
}), /*#__PURE__*/React.createElement("path", {
  className: "calculator_svg__cls-2",
  d: "M32.62 124.18a10.06 10.06 0 11-10-10.06 10.05 10.05 0 0110 10.06zM57.38 124.18a10.06 10.06 0 11-10.06-10.06 10.05 10.05 0 0110.06 10.06z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 72.08,
  cy: 124.18,
  r: 10.05
}), /*#__PURE__*/React.createElement("path", {
  className: "calculator_svg__cls-2",
  d: "M32.62 150.14a10.06 10.06 0 11-10-10 10.05 10.05 0 0110 10zM57.38 150.14a10.06 10.06 0 11-10.06-10 10.05 10.05 0 0110.06 10z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "calculator_svg__cls-2",
  cx: 72.08,
  cy: 150.14,
  r: 10.05
}), /*#__PURE__*/React.createElement("path", {
  className: "calculator_svg__cls-2",
  d: "M106.84 125.07a8.69 8.69 0 000-.89 10.06 10.06 0 10-20.11 0v26a10.06 10.06 0 1020.11 0 8.69 8.69 0 000-.89z"
})));

function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 177,
    viewBox: "0 0 119.4 177.52"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgCalculator as ReactComponent };